import { Modal } from "antd";
import * as React from 'react';
import Draggable from 'react-draggable';
import { checkSliderCaptcha, getSliderPosition } from "@/fetch/api/personal";
import './style.less';

class SliderValidate extends React.Component {
  constructor(props, context) {
    super(props, context), this.state = {
      domain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev.yunduoketang.cn',
      sliderBg: "",
      sliderDrag: "",
      sliderX: 0,
      sliderY: 0,
      result: 0 //0 未验证  1 成功  2 失败

    };
  }

  componentDidMount() {
    this.getSliderImg();
  }

  getSliderImg = () => {
    this.setState({
      sliderBg: `/s/api/saas-business/v1/student/setting/get/captcha/base/image?refresh=${new Date().getTime()}&domain=${this.state.domain}${this.props.type == 'register' ? '&module=index' : ''}` // sliderBg:"/s/api/saas-business/v1/student/setting/get/captcha/base/image?refresh="+new Date().getTime()+"&domain="+this.state.domain

    });
  };
  getDrag = () => {
    let params = {
      domain: this.state.domain
    };
    if (this.props.type == 'register') params.module = 'index';
    getSliderPosition(params).then(res => {
      if (res.success) {
        this.setState({
          sliderX: 0,
          result: 0,
          sliderY: res.data,
          sliderDrag: `/s/api/saas-business/v1/student/setting/get/captcha/tar?refresh=${new Date().getTime()}&domain=${this.state.domain}${this.props.type == 'register' ? '&module=index' : ''}`
        });
      }
    });
  };
  handleDrag = (e, data) => {
    this.setState({
      sliderX: data.x
    });
  };
  handleStop = (e, data) => {
    this.setState({
      sliderX: data.x
    }, () => {
      let params = {
        x: Math.round(data.x),
        y: Math.round(this.state.sliderY),
        domain: this.state.domain
      };
      if (this.props.type == 'register') params.module = 'index';
      checkSliderCaptcha(params).then(res => {
        if (res.success && res.data) {
          this.setState({
            result: 1
          });
          setTimeout(() => {
            this.props.callback({
              x: data.x,
              y: this.state.sliderY
            });
          }, 1000);
        } else {
          this.setState({
            result: 2
          });
          setTimeout(() => {
            this.getSliderImg();
          }, 1000);
        }
      });
    });
  };

  render() {
    const {
      type
    } = this.props;
    return <Modal data-inspector-line="77" data-inspector-column="6" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" title="请完成安全验证" visible={true} onCancel={() => this.props.handleCancelVerify()} width={326} footer={null} className="slider-validation">
        <div data-inspector-line="85" data-inspector-column="8" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className={`slider-img-box ${type == 'register' ? 'reg-slider-img-box' : ''}`}>
          <i data-inspector-line="86" data-inspector-column="10" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="iconfont icongengxin" onClick={this.getSliderImg}></i>
          <img data-inspector-line="87" data-inspector-column="10" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="slider-bg" src={this.state.sliderBg} onLoad={this.getDrag} />
          <img data-inspector-line="88" data-inspector-column="10" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="slider-drag" style={{
          left: this.state.sliderX,
          top: this.state.sliderY
        }} src={this.state.sliderDrag} />
        </div>
        <div data-inspector-line="90" data-inspector-column="8" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className={`slider-container ${type == 'register' ? 'reg-slider-container' : ''}}`}>
          {this.state.result == 0 && <span data-inspector-line="91" data-inspector-column="33" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx">向右拖动滑块,进行验证</span>}
          <Draggable data-inspector-line="92" data-inspector-column="10" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" axis="x" position={{
          x: this.state.sliderX,
          y: 0
        }} bounds={{
          left: 0,
          right: 236
        }} onDrag={this.handleDrag} onStop={this.handleStop}>
            <div data-inspector-line="99" data-inspector-column="12" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="slider-icon" style={{
            left: this.state.sliderX > 0 ? 0 : -1
          }}>
              <i data-inspector-line="100" data-inspector-column="14" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="iconfont iconjiantou"></i>
            </div>
          </Draggable>
          <div data-inspector-line="103" data-inspector-column="10" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className={`slider-mask ${this.state.result == 1 ? "success" : this.state.result == 2 ? "failure" : ""}`} style={{
          width: this.state.sliderX
        }}>
            {this.state.result == 1 && <span data-inspector-line="104" data-inspector-column="35" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="success"><i data-inspector-line="104" data-inspector-column="61" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="iconfont iconchenggong2"></i>验证成功！</span>}
            {this.state.result == 2 && <span data-inspector-line="105" data-inspector-column="35" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="failure"><i data-inspector-line="105" data-inspector-column="61" data-inspector-relative-path="src\\components\\SliderValidate\\index.jsx" className="iconfont iconshibai1"></i>验证失败！</span>}
          </div>
        </div>
      </Modal>;
  }

}

export default SliderValidate;